import { Component } from '@angular/core';

@Component({
    selector: 'about-component',
    templateUrl: './about.component.html',
    standalone: false
})
export class AboutComponent {
  links: any[] = [];
}
